// extracted by mini-css-extract-plugin
export default {"FormCreateCourse":"FormCreateCourse_FormCreateCourse__VsXnj"};